import { render } from "./ThongTinXe.vue?vue&type=template&id=7dd6f47b&scoped=true"
import script from "./ThongTinXe.vue?vue&type=script&lang=js"
export * from "./ThongTinXe.vue?vue&type=script&lang=js"

import "./ThongTinXe.vue?vue&type=style&index=0&id=7dd6f47b&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd6f47b"]])

export default __exports__